// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SwzukuLn_1xxIGEcgRSa {
    --background-color: rgb(255 229 174);

    --passive-color: #5e5e5e;
    --active-color: hsl(0deg 0% 18.4%);
    width: 100%;
    height: 8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    background-color: var(--background-color);
    color: #ededed;
    /* border: 1px solid var(--passive-color); */
    border-radius: 8px;
    box-shadow: 0 0 0.5rem 0 rgb(255 255 255 / 65%);
    transition: all 0.5s ease;
}

.SwzukuLn_1xxIGEcgRSa:hover {
    box-shadow: 0 0 0.8rem 0 rgb(255 255 255 / 95%);
}

.SwzukuLn_1xxIGEcgRSa>hr{
    height: 0;
    background-color: var(--passive-color);

    border: 0.5px solid var(--passive-color);
    margin: 0;

    transition: border 0.3s ease;
}

.SwzukuLn_1xxIGEcgRSa:hover>hr {
    border: 0.5px solid var(--active-color);
}

.SwzukuLn_1xxIGEcgRSa>p {
    margin: 0;
    margin-left: 15px;

    font-size: 0.7rem;
    font-weight: 500;

    color: var(--passive-color);

    transition: color 0.3s ease;
}

.SwzukuLn_1xxIGEcgRSa:hover>p {
    color: var(--active-color);
}

.SwzukuLn_1xxIGEcgRSa button {
    position: relative;
    width: 90%;

    font-size: 0.85rem;
    font-weight: bold;
    color: var(--passive-color);
    fill: var(--passive-color);
    background-color: var(--background-color);

    padding-left: 15px;
    padding-right: 15px;
    border: 1px solid var(--passive-color);
    border-radius: 1rem;

    z-index: 1;

    justify-content: space-between;

    transition: all 0.3s ease;
}

.SwzukuLn_1xxIGEcgRSa button:hover, .SwzukuLn_1xxIGEcgRSa button:focus {
    /* background-color: rgb(40, 40, 43); */
    color: var(--active-color);
    fill: var(--active-color);
    border: 1px solid var(--active-color);
}

.SwzukuLn_1xxIGEcgRSa button>svg {
    width: 1.25rem;
    height: 1.25rem;
}

.SwzukuLn_1xxIGEcgRSa button.D0c3spcp_mB7cTX5yDZr {
    border-radius: 1rem 1rem 0 0;
}

.SwzukuLn_1xxIGEcgRSa select {
    display: none;
}

.RpY2narLhESbHb5xHZF7 {
    position: absolute;
    top: 50%;
    left: 5%;

    background-color: var(--background-color);

    width: 90%;
    z-index: 0;

    padding-top: 1rem;

    border: 0px solid var(--active-color);
    border-radius: 0 0 0.5rem 0.5rem;

    max-height: 0;
    transition: all 0.2s ease;
    overflow-y: auto;
}

.RpY2narLhESbHb5xHZF7::-webkit-scrollbar {
    display: none;
}

.RpY2narLhESbHb5xHZF7._mRQ4hkIq1e9kkPDBslR {
    transition: all 0.2s ease;

    max-height: 15rem;

    border-width: 1px;
    border-top: 0;
    border-radius: 0 0 1rem 1rem;
}

.RpY2narLhESbHb5xHZF7>.GjTe2lE76wJY1VJwnjKg {
    display: flex;
    flex-direction: column;

    list-style-type: none;

    padding: 0.7rem 0 0.7rem 1rem;
}

@keyframes q2jssIlxFjmnknPtnubA {
    0% {
        height: 0;
    }

    100% {
        height: 1.2rem;
    }
}

@keyframes FU5KnEB6n_exBOGGqfOD {
    0% {
        opacity: 0;
    }

    75% {
        opacity: 1;
    }

    100% {
        transform: scale(1.2);
    }
}

.DAw86yFK4NzzAp3zeiID {
    display: none;
}

.DAw86yFK4NzzAp3zeiID+label {
    color: var(--passive-color);

    font-family: monospace;
    font-size: 0.85rem;
}

.DAw86yFK4NzzAp3zeiID+label:hover, .DAw86yFK4NzzAp3zeiID:checked+label {
    color: var(--active-color);
}

.DAw86yFK4NzzAp3zeiID+label span {
    display: inline-block;
    width: 25px;
    height: 19px;
    margin: 0 5px -4px 0;
    /*layout relationship between check and label*/
}

.DAw86yFK4NzzAp3zeiID+label span:before,
.DAw86yFK4NzzAp3zeiID+label span:after{
    transition: all 0.3s ease-in-out;
    content: "";
    position: absolute;
    z-index: 1;
    width: 1rem;
    height: 1rem;
    background: transparent;
    border: 2px solid var(--active-color);
}

.DAw86yFK4NzzAp3zeiID+label span:after {
    z-index: 0;
    border: none;
}

.DAw86yFK4NzzAp3zeiID:checked+label span:before {
    transform: rotateY(180deg);
    background: var(--active-color);
}`, "",{"version":3,"sources":["webpack://./src/js/VaccineStock/RegionalSection/DropdownBlock/DropdownComponent/styles.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;;IAEpC,wBAAwB;IACxB,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,yCAAyC;IACzC,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;IAClB,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,SAAS;IACT,sCAAsC;;IAEtC,wCAAwC;IACxC,SAAS;;IAET,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,iBAAiB;;IAEjB,iBAAiB;IACjB,gBAAgB;;IAEhB,2BAA2B;;IAE3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;;IAEV,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,0BAA0B;IAC1B,yCAAyC;;IAEzC,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;;IAEnB,UAAU;;IAEV,8BAA8B;;IAE9B,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;IAC1B,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;;IAER,yCAAyC;;IAEzC,UAAU;IACV,UAAU;;IAEV,iBAAiB;;IAEjB,qCAAqC;IACrC,gCAAgC;;IAEhC,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;;IAEzB,iBAAiB;;IAEjB,iBAAiB;IACjB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,qBAAqB;;IAErB,6BAA6B;AACjC;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;;IAE3B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;;IAEI,gCAAgC;IAChC,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;AACnC","sourcesContent":[".dropdown {\n    --background-color: rgb(255 229 174);\n\n    --passive-color: #5e5e5e;\n    --active-color: hsl(0deg 0% 18.4%);\n    width: 100%;\n    height: 8rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    background-color: var(--background-color);\n    color: #ededed;\n    /* border: 1px solid var(--passive-color); */\n    border-radius: 8px;\n    box-shadow: 0 0 0.5rem 0 rgb(255 255 255 / 65%);\n    transition: all 0.5s ease;\n}\n\n.dropdown:hover {\n    box-shadow: 0 0 0.8rem 0 rgb(255 255 255 / 95%);\n}\n\n.dropdown>hr{\n    height: 0;\n    background-color: var(--passive-color);\n\n    border: 0.5px solid var(--passive-color);\n    margin: 0;\n\n    transition: border 0.3s ease;\n}\n\n.dropdown:hover>hr {\n    border: 0.5px solid var(--active-color);\n}\n\n.dropdown>p {\n    margin: 0;\n    margin-left: 15px;\n\n    font-size: 0.7rem;\n    font-weight: 500;\n\n    color: var(--passive-color);\n\n    transition: color 0.3s ease;\n}\n\n.dropdown:hover>p {\n    color: var(--active-color);\n}\n\n.dropdown button {\n    position: relative;\n    width: 90%;\n\n    font-size: 0.85rem;\n    font-weight: bold;\n    color: var(--passive-color);\n    fill: var(--passive-color);\n    background-color: var(--background-color);\n\n    padding-left: 15px;\n    padding-right: 15px;\n    border: 1px solid var(--passive-color);\n    border-radius: 1rem;\n\n    z-index: 1;\n\n    justify-content: space-between;\n\n    transition: all 0.3s ease;\n}\n\n.dropdown button:hover, .dropdown button:focus {\n    /* background-color: rgb(40, 40, 43); */\n    color: var(--active-color);\n    fill: var(--active-color);\n    border: 1px solid var(--active-color);\n}\n\n.dropdown button>svg {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n.dropdown button.clicked {\n    border-radius: 1rem 1rem 0 0;\n}\n\n.dropdown select {\n    display: none;\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 50%;\n    left: 5%;\n\n    background-color: var(--background-color);\n\n    width: 90%;\n    z-index: 0;\n\n    padding-top: 1rem;\n\n    border: 0px solid var(--active-color);\n    border-radius: 0 0 0.5rem 0.5rem;\n\n    max-height: 0;\n    transition: all 0.2s ease;\n    overflow-y: auto;\n}\n\n.dropdown-menu::-webkit-scrollbar {\n    display: none;\n}\n\n.dropdown-menu.show {\n    transition: all 0.2s ease;\n\n    max-height: 15rem;\n\n    border-width: 1px;\n    border-top: 0;\n    border-radius: 0 0 1rem 1rem;\n}\n\n.dropdown-menu>.option-holder {\n    display: flex;\n    flex-direction: column;\n\n    list-style-type: none;\n\n    padding: 0.7rem 0 0.7rem 1rem;\n}\n\n@keyframes pull {\n    0% {\n        height: 0;\n    }\n\n    100% {\n        height: 1.2rem;\n    }\n}\n\n@keyframes pop {\n    0% {\n        opacity: 0;\n    }\n\n    75% {\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(1.2);\n    }\n}\n\n.checkbox-flip {\n    display: none;\n}\n\n.checkbox-flip+label {\n    color: var(--passive-color);\n\n    font-family: monospace;\n    font-size: 0.85rem;\n}\n\n.checkbox-flip+label:hover, .checkbox-flip:checked+label {\n    color: var(--active-color);\n}\n\n.checkbox-flip+label span {\n    display: inline-block;\n    width: 25px;\n    height: 19px;\n    margin: 0 5px -4px 0;\n    /*layout relationship between check and label*/\n}\n\n.checkbox-flip+label span:before,\n.checkbox-flip+label span:after{\n    transition: all 0.3s ease-in-out;\n    content: \"\";\n    position: absolute;\n    z-index: 1;\n    width: 1rem;\n    height: 1rem;\n    background: transparent;\n    border: 2px solid var(--active-color);\n}\n\n.checkbox-flip+label span:after {\n    z-index: 0;\n    border: none;\n}\n\n.checkbox-flip:checked+label span:before {\n    transform: rotateY(180deg);\n    background: var(--active-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `SwzukuLn_1xxIGEcgRSa`,
	"clicked": `D0c3spcp_mB7cTX5yDZr`,
	"dropdown-menu": `RpY2narLhESbHb5xHZF7`,
	"show": `_mRQ4hkIq1e9kkPDBslR`,
	"option-holder": `GjTe2lE76wJY1VJwnjKg`,
	"checkbox-flip": `DAw86yFK4NzzAp3zeiID`,
	"pull": `q2jssIlxFjmnknPtnubA`,
	"pop": `FU5KnEB6n_exBOGGqfOD`
};
export default ___CSS_LOADER_EXPORT___;
